module.exports = __webpack_public_path__ + "img/horizontal_4_3_8003.fe319689.png";